export const addUrdPurchase = async (data) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addURDPurchase", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...data})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data_res = data;
        data_res.id = jsonResponse?.data?.id;
        jsonResponse.data = data_res;
    }
    console.log('Add Urd Purchase Response:', response);
    return jsonResponse;
};
export const updateUrdPurchase = async (urdId, urdData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateURDPurchase", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: urdId, ...urdData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data_res = urdData;
        data_res.id = urdId;
        jsonResponse.data = data_res;
    }
    console.log('Update Urd Purchase Response:', response);
    return jsonResponse;
};
export const deleteUrdPurchase = async (urdId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteURDPurchase", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: urdId})
    });
    return await response.json();
};
